module.exports = __webpack_public_path__ + "img/student1.7ee1b14c.jpg";